import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoEmail from 'eco-design/elements/eco-email';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import EcoButton from 'eco-design/base/eco-button';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA1');
    const contactListId = ['2037968306'];
    return (
        <div className="eco-content" id="eco-content">
            <EcoSpace />
            <div className={styles.comp}>
                <div className="comp-l">
                    <div className="comp-l-title">{t('l_title')}</div>
                    <div className="comp-l-desc">{t('l_desc')}</div>
                    <EcoEmail
                        termsHtml='<a href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">プライバシーポリシー</a>と<a href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">利用規約</a>に同意します。'
                        contactListId={contactListId}
                        defaultTermsCheck
                        tipsObj={{ btnText: t('l_btn'), tipsCheck: t('tipsCheck'), tipsEmpty: 'メールアドレス' }}
                        source="WEB_NEW_PRODUCT_SUB"
                        fields={[
                            {
                                id: '9120',
                                type: 'multiple',
                                value: [24],
                                overwrite: false,
                            },
                            {
                                id: '31',
                                type: 'single',
                                value: 1,
                                overwrite: true,
                            },
                            {
                                id: '4431',
                                type: 'single',
                                value: 1,
                                overwrite: true,
                            },
                        ]}
                        subscribeData={{
                            sector_name: t('l_title'),
                            entry_position: 2,
                        }}
                    />
                </div>
                <div className="comp-line"></div>
                <div className="comp-r">
                    <div className="comp-r-title">{t('r_title')}</div>
                    <div className="comp-r-desc">{t('r_desc')}</div>
                    <div className="comp-r-bottom">
                        <div className="comp-r-img">
                            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1742182718560/M_gainfriends_2dbarcodes_GW%201.png" />
                        </div>
                        <EcoButton
                            lHref="https://lin.ee/DoTZhMu"
                            className="comp-r-btn"
                            lBgColor="#06C755"
                            lDataLayer={{
                                event: 'uaEvent',
                                event_name: 'line_icon_click',
                                button_name: 'LINE',
                                url: 'https://lin.ee/DoTZhMu',
                            }}
                        >
                            {t('r_btn')}
                        </EcoButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
